import { generateUtilityClass, generateUtilityClasses } from "@mui/material";
const cardName = "TidalCard";
const cardClasses = generateUtilityClasses(cardName, [
  "root",
  "content",
  "icon",
  "actions",
  "heading",
  "body"
]);
function getCardUtilityClass(slot) {
  return generateUtilityClass(cardName, slot);
}
export {
  cardClasses,
  cardName,
  getCardUtilityClass
};
//# sourceMappingURL=classes.js.map
